import { HttpParams } from '@angular/common/http';

export interface Pagination {
  page: number;
  size: number;
  sort: string[];
}

export interface Search {
  query: string;
}

export interface AccessHistorySearch extends Pagination {
  creationTimeFrom?: string;
  requestCountry: string;
  deviceName: string;
  deviceApplication: string;
  reportedAccessStatus: string;
  reportedAccessDateFrom?: string;
  newDevice?: boolean;
}

export interface SearchWithPagination extends Search, Pagination { }

export function createRequestOption<T extends Pagination>(req?: T): HttpParams {
  let options: HttpParams = new HttpParams();

  if (req) {
    Object.entries(req).forEach(([key, value]) => {
      if (key !== 'sort') {
        options = options.set(key, value);
      }
    });

    if (req.sort) {
      req.sort.forEach((val: string) => {
        options = options.append('sort', val);
      });
    }
  }

  return options;
};

export const getCompanyName = (): string | undefined => {
  let companyName = undefined;
  const ayPath = window.location.pathname.split('/');

  if (ayPath.length > 1 && ayPath[1] !== '') {
    companyName = ayPath[1];
  }

  return companyName;
};

export const redirectToGlobalErrorPage = (errorUrl: string, clientId: string, errorCode: string): void => {
  const redirectUri = `&redirect_uri=${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  const errorCodeUri = `&error_code=PA-${errorCode}`;
  const errorPageUrl = `${errorUrl}?client_id=${clientId}&realm=pec${redirectUri}${errorCodeUri}`;

  window.location.href = errorPageUrl;
};

export const redirectToLogoutErrorPage = (logoutUrl: string, errorUrl: string, clientId: string, errorCode: string): void => {
  const errorCodeUri = `&error_code=PA-${errorCode}`;
  const redirectUri = `&redirect_uri=${window.location.protocol}//${window.location.host}${window.location.pathname.slice(0, -1)}`;
  const errorPageUrl = `${errorUrl}?client_id=${clientId}&realm=pec${errorCodeUri}${redirectUri}`
  const logouttUrl = `${logoutUrl}?redirect_uri=${encodeURIComponent(errorPageUrl)}`;
  window.location.href = logouttUrl;
};
